import type { PromisePool } from "@bankmonitor/bm-ui-kit";
import type { AuthenticationContextType } from "@service/AuthenticationContext";
import AuthenticationService from "@service/AuthenticationService";
import type { UserData } from "@service/AuthenticationService.type";

const CUSTOMER_LOAD_DELAY_MS = 500;

export interface PasswordCredentials {
	email: string;
	password: string;
}

interface MfaSignInDependencies {
	auth: Pick<AuthenticationContextType, "setMFAStatus" | "setUser">;
	promisePool: PromisePool;
}

export async function signInForMfa({ auth, promisePool }: MfaSignInDependencies, { email, password }: PasswordCredentials): Promise<UserData> {
	auth.setMFAStatus("none");

	await promisePool.add(AuthenticationService.login(email, password));
	await promisePool.addTimeout(CUSTOMER_LOAD_DELAY_MS);

	const customer = await promisePool.add(AuthenticationService.getUserData());
	auth.setUser(customer);

	return customer;
}
